import { ChangeEvent } from "react";
import { useIntl } from "react-intl";
import { Grid, useMediaQuery } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { Breadcrumbs, PageHeader } from "@dzambalaorg/mui-page-layout";
import { InputType, IPaginationResult } from "@dzambalaorg/types-collection";
import type { IToken } from "@framework/types";
import { TokenType } from "@framework/types";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { PonziLeaderboardSearchForm } from "./search";
import { columnsCreator } from "./utils";

const initialSearchValues = {
  deposit: {
    tokenType: TokenType.ERC20,
    contractId: InputType.awaited,
  },
  reward: {
    tokenType: TokenType.ERC20,
    contractId: InputType.awaited,
  },
};

export const PonziLeaderboard = () => {
  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, allRows, totalCount } = useFetchQuery<IPaginationResult<IToken>>(
    "/ponzi/leaderboard",
    { enableInfiniteScroll: isMd },
    void 0,
    initialSearchValues,
  );

  const { formatMessage } = useIntl();

  const columns = columnsCreator(skip, formatMessage);

  return (
    <Grid>
      <Breadcrumbs path={["dashboard", "ponzi", "ponzi.leaderboard"]} />

      <PageHeader message="pages.ponzi.leaderboard.title" />

      <PonziLeaderboardSearchForm initialValues={initialSearchValues} />

      <DataGrid
        pagination
        paginationMode="server"
        rowCount={totalCount}
        paginationModel={{ page: skip / take, pageSize: take }}
        onPaginationModelChange={({ page }) => onChangePage({} as ChangeEvent<unknown>, page)}
        pageSizeOptions={[5, 10, 25]}
        loading={isLoading}
        columns={columns}
        rows={allRows}
      />
    </Grid>
  );
};
